<template>
  <Select
    v-model="selectedProject"
    filterable
    clearable
    @change="ProjectChange"
    :disabled="disabled"
    class="wd-100p"
  >
    <Option
      :value="p.id"
      :label="p.nm"
      :key="p.id"
      v-for="p in projects"
    ></Option>
  </Select>
</template>

<script>
import { Select, Option } from "element-ui";
import { request } from "@/api/all";

export default {
  components: {
    Select,
    Option
  },
  props: {
    id: {
      type: Number,
      default: () => null
    },
    disabled: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      selectedProject: null,
      projects: []
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      request({
        api: { url: "Task/GetSharedToFirstColumnProjects", method: "GET" },
        store: self.$store
      }).then(res => {
        this.projects = res.data.projects;
        if (this.id != undefined && this.id > 0) {
          //console.log(this.id);
          this.selectedProject = this.id;
        }
      });
    },
    ProjectChange(e) {
      let cur = this.projects.filter(p => p.id === e)[0];
      // this.$emit("input", cur.id);
      this.$emit("on-proj-selected", { id: cur.id, ot: cur.ot, first: false });
    }
  }
};
</script>

<style></style>
